import React from "react";
import moment from "moment";
import "moment/locale/id";
import ListCard from "./ListCard";
import TargetDetected from "./TargetDetected"
// import LoginHistory from "./LoginHistory";
import MapDashboard from "./Map";

function DashboardHome() {
  // Set locale ke Indonesia
  moment.locale("id");
  // Simpan tanggal terformat ke dalam variabel
  const getToday = moment().format("dddd, D MMMM YYYY");

  return (
    <div className="">
      <div className="text-lg font-bold text-end gap-2 pb-5">{getToday}</div>
      <div className="mb-4">
        <ListCard />
      </div>
      <div className="w-full h-64 sm:h-96 md:h-[500px] relative border-solid border-gray-300 border rounded-xl shadow-md overflow-hidden">
        <MapDashboard />
      </div>
      <div className="my-4">
        <TargetDetected />
      </div>
      {/* <div className="my-4">
        <LoginHistory />
      </div> */}
    </div>
  );
}

export default DashboardHome;
